"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intents = void 0;

var _CheckCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/CheckCircle"));

var _ExclamationCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationCircle"));

var _ExclamationTriangle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationTriangle"));

var _InfoCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/InfoCircle"));

var _QuestionCircle = _interopRequireDefault(require("@decisiv/iconix/lib/components/QuestionCircle"));

var _commonUIColors = require("../../utils/commonUIColors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var danger = _commonUIColors.commonUIColors.danger,
    information = _commonUIColors.commonUIColors.information,
    licoriceMousse = _commonUIColors.commonUIColors.licoriceMousse,
    success = _commonUIColors.commonUIColors.success,
    warning = _commonUIColors.commonUIColors.warning; // eslint-disable-next-line import/prefer-default-export

var intents = {
  danger: {
    color: danger,
    icon: _ExclamationTriangle.default
  },
  help: {
    color: licoriceMousse,
    icon: _QuestionCircle.default
  },
  information: {
    color: information,
    icon: _InfoCircle.default
  },
  success: {
    color: success,
    icon: _CheckCircle.default
  },
  warning: {
    color: warning,
    icon: _ExclamationCircle.default
  }
};
exports.intents = intents;